'use strict';

/**
 * @ngdoc directive
 * @name v-tv-package-add-to-cart
 * @restrict E
 *
 * @description
 * #directive
 * Add or remove item from the current active cart. Hides this feature if cart is disabled
 *
 * @template:'<button type="button" class="mplex-add" ng-show="!$ctrl.isCartDisabled && !$ctrl.getIsALaCarte()" ng-click="$ctrl.addToCart()" ng-transclude></button>'
 * @param {object} item the mplex element to add to the active cart
 */
angular.module('v-tv-package').component('vTvPackageAddToCart', {
    bindings: {
        item: '=',
        isCartDisabled: '<'
    },
    transclude: true,
    template:'<button type="button" class="mplex-add" ng-show="!$ctrl.isCartDisabled && !$ctrl.getIsALaCarte()" ng-click="$ctrl.addToCart()" ng-transclude></button>',
    controller: function controller(TvPackageSelectionStateService, $q, $analytics) {
        var _this = this;

        this.addToCart = function () {
            var cart = TvPackageSelectionStateService.getActiveCart();

            if (cart.has(_this.item.id)) {
                cart.remove(_this.item.id);
                _this.item.isSelected = false;
            } else {
                cart.add(_this.item.id);
                _this.item.isSelected = true;
                $analytics.eventTrack('choisir une chaîne', {
                    category: 'outils d\'aide à la décision',
                    label: _this.item.label
                });
            }

            return $q.all([TvPackageSelectionStateService.saveActiveCart(), TvPackageSelectionStateService.getSelectionState()]).finally(function () {
                _this.isCartDisabled = TvPackageSelectionStateService.getActiveCart().getIsDisabled();
            });
        };

        this.isCartDisabled = TvPackageSelectionStateService.getActiveCart().getIsDisabled();
        this.getIsALaCarte = function () {
            return TvPackageSelectionStateService.isALaCarte();
        };
    }
});